module.exports = __webpack_public_path__ + "img/open.138eb44c.svg";